/**
 * PV Quiz Viking - Offer Page (Screen 13) behavior.
 * Runs independently of pv-quiz-viking.js (this section lives outside the
 * quiz container in the DOM) but reaches into the shared quiz instance via
 * window.PVQuizVikingApp to advance to Screen 14 and keep tracking/meta
 * state in one place.
 */

(function () {
  'use strict';

  var ANSWERS_KEY = 'pv_quiz_viking_answers';

  function readAnswers() {
    try {
      var raw = sessionStorage.getItem(ANSWERS_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  // The real tier-picker now lives in the reused pv-product-section instance
  // (q13_product) - look up a variant card there by jar count so "Try it
  // once" (which bypasses that picker entirely) still fills the same meta
  // fields the offer-bridge script writes when a tier IS picked interactively.
  function findVariantCardByJarCount(jarCount) {
    var scope = document.querySelector('[id*="__q13_product"]');
    if (!scope) return null;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('[data-pv-variant-card]'));
    return (
      cards.filter(function (card) {
        var nameEl = card.querySelector('.pv-product__variant-name');
        var match = nameEl ? /(\d+)/.exec(nameEl.textContent) : null;
        return match && parseInt(match[1], 10) === jarCount;
      })[0] || null
    );
  }

  // Callers fire their own specific tracking event (main CTA / sticky CTA /
  // try-once all land here, so this only handles the navigation + meta side).
  function goToOrderSummary(purchaseType, tierNumber) {
    var app = window.PVQuizVikingApp;
    if (!app) {
      window.location.hash = '#step-15';
      return;
    }

    var payload = { selectedTier: tierNumber, purchaseType: purchaseType };
    var card = findVariantCardByJarCount(tierNumber);
    if (card) {
      var nameEl = card.querySelector('.pv-product__variant-name');
      var saveEl = card.querySelector('.pv-product__variant-save');
      var titleEl = document.querySelector('[id*="__q13_product"] .pv-product__title');
      payload.pvVariantId = card.getAttribute('data-variant-id');
      payload.pvSellingPlanId = purchaseType === 'one_time' ? null : card.getAttribute('data-selling-plan');
      payload.pvProductTitle = titleEl ? titleEl.textContent.trim() : '';
      payload.pvTierLabel = nameEl ? nameEl.textContent.trim() : '';
      payload.pvPriceTotal =
        purchaseType === 'one_time' ? card.getAttribute('data-compare-total') : card.getAttribute('data-price-total');
      payload.pvCompareTotal = card.getAttribute('data-compare-total');
      payload.pvSaveText = saveEl ? saveEl.textContent.trim() : '';
      // Lets the add-on match this tier's delivery frequency - null for a
      // one-time purchase, since there's no recurring cadence to match.
      payload.pvRefillDays = purchaseType === 'one_time' ? null : card.getAttribute('data-refill-days');
    }

    app.setMeta(payload);
    app.goToStep(15);
  }

  function initPrimary() {
    var root = document.querySelector('[data-offer-part="primary"]');
    if (!root) return;

    var tierCards = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var selectedTier = 1;

    function selectTier(tierNumber) {
      selectedTier = tierNumber;
      var activeCard = null;

      tierCards.forEach(function (card) {
        var isMatch = parseInt(card.dataset.tier, 10) === tierNumber;
        card.classList.toggle('is-selected', isMatch);
        if (isMatch) activeCard = card;
      });

      if (!activeCard) return;

      root.querySelectorAll('[data-cta-price]').forEach(function (el) {
        el.textContent = activeCard.dataset.price;
      });
      root.querySelectorAll('[data-cta-compare-price]').forEach(function (el) {
        el.innerHTML = '<del>' + activeCard.dataset.comparePrice + '</del>';
      });
    }

    // Re-run on every visit to the offer step (not just page load) so
    // personalization stays in sync if the user goes back and changes an
    // answer, then returns here - this is the only step-14 source that was
    // otherwise stuck with whatever answers existed at DOMContentLoaded.
    function personalize() {
      var answers = readAnswers();
      var P = window.PVQuizVikingPersonalization;

      var paragraphEl = root.querySelector('[data-personalized-paragraph]');
      if (paragraphEl && P) {
        paragraphEl.textContent = P.assembleParagraph(answers);
      }

      var bulletsEl = root.querySelector('[data-benefit-bullets]');
      if (bulletsEl && P) {
        bulletsEl.innerHTML = '';
        P.getBenefitBullets(answers.q1).forEach(function (text) {
          var li = document.createElement('li');
          li.textContent = text;
          bulletsEl.appendChild(li);
        });
      }

      var recommendedTier = P ? P.getRecommendedTier(answers.q9) : null;

      tierCards.forEach(function (card) {
        var isRecommended = !!recommendedTier && parseInt(card.dataset.tier, 10) === recommendedTier;
        card.classList.toggle('is-recommended', isRecommended);
        var badge = card.querySelector('[data-tier-badge]');
        if (badge) badge.hidden = !isRecommended;
      });

      if (tierCards.length) selectTier(recommendedTier || 1);
    }

    personalize();

    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#step-14') personalize();
    });

    root.addEventListener('click', function (e) {
      var tierCard = e.target.closest('[data-tier]');
      if (tierCard) {
        selectTier(parseInt(tierCard.dataset.tier, 10));
        var app = window.PVQuizVikingApp;
        if (app) app.trackEvent('quiz_tier_selected', { tier: selectedTier });
        return;
      }

      var claimBtn = e.target.closest('[data-action="claim-offer"]');
      if (claimBtn) {
        var isSticky = !!claimBtn.closest('[data-sticky-bar]');
        var app2 = window.PVQuizVikingApp;
        if (app2) {
          app2.trackEvent(isSticky ? 'quiz_sticky_cta_click' : 'quiz_offer_cta_click', { tier: selectedTier });
        }
        goToOrderSummary('subscription', selectedTier);
        return;
      }

      var scrollBtn = e.target.closest('[data-action="scroll-to-before-after"]');
      if (scrollBtn) {
        var target = document.getElementById('shopify-section-q13_before_after');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      }
    });

    var tierPicker = root.querySelector('[data-tier-picker]');
    var stickyBar = root.querySelector('[data-sticky-bar]');
    if (tierPicker && stickyBar && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.hidden = true;
          } else {
            // Only show once we've scrolled past it (it's above the viewport) -
            // stay hidden while the user hasn't reached it yet.
            stickyBar.hidden = entry.boundingClientRect.top > 0;
          }
        });
      });
      observer.observe(tierPicker);
    }
  }

  function initStory() {
    var root = document.querySelector('[data-offer-part="story"]');
    if (!root) return;

    root.addEventListener('click', function (e) {
      var tryOnceBtn = e.target.closest('[data-action="try-once"]');
      if (tryOnceBtn) {
        e.preventDefault();
        var app = window.PVQuizVikingApp;
        if (app) app.trackEvent('quiz_try_once_click', {});
        goToOrderSummary('one_time', 1);
      }
    });
  }

  function init() {
    initPrimary();
    initStory();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
